"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9851],{

/***/ 39851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ useAuth; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/swr/esm/index.js + 8 modules
var esm = __webpack_require__(45522);
// EXTERNAL MODULE: ./src/lib/axios.js
var axios = __webpack_require__(97418);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/cookie-cutter/index.js
var cookie_cutter = __webpack_require__(49552);
var cookie_cutter_default = /*#__PURE__*/__webpack_require__.n(cookie_cutter);
// EXTERNAL MODULE: ./src/hooks/loader.js
var hooks_loader = __webpack_require__(52026);
// EXTERNAL MODULE: ./src/utilities.js
var utilities = __webpack_require__(66156);
// EXTERNAL MODULE: ./src/constants.js
var constants = __webpack_require__(10288);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./src/services/slices/usersSlice/index.js
var usersSlice = __webpack_require__(59612);
// EXTERNAL MODULE: ./src/lib/axiosAuth.js
var axiosAuth = __webpack_require__(31746);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
;// CONCATENATED MODULE: ./src/lib/axiosMeet.js
/* provided dependency */ var process = __webpack_require__(34155);

var axiosMeet = axios_default().create({
  baseURL: process.env.NEXT_PUBLIC_TACNIQUE_ASYNC_MEET_BACKEND_URL
});
/* harmony default export */ var lib_axiosMeet = ((/* unused pure expression or super */ null && (axiosMeet)));
;// CONCATENATED MODULE: ./src/hooks/auth.js



var _excluded = ["setErrors", "setNotification"],
    _excluded2 = ["setErrors", "setStatus"],
    _excluded3 = ["setErrors", "setStatus"],
    _excluded4 = ["setErrors", "setStatus"],
    _excluded5 = ["setErrors", "setStatus"],
    _excluded6 = ["setErrors", "setStatus"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var useAuth = function useAuth() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      middleware = _ref.middleware,
      redirectIfAuthenticated = _ref.redirectIfAuthenticated;

  var loader = (0,hooks_loader/* default */.Z)();
  var router = (0,next_router.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();
  var token = null;
  var destination_path = null;

  var _useSWR = (0,esm/* default */.ZP)("/api/user", /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var token, response, userData, _error$response, _error$response3, _error$response2, _error$response2$data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            token = cookie_cutter_default().get("accessToken");

            if (token) {
              _context.next = 3;
              break;
            }

            throw new Error("No token found");

          case 3:
            _context.prev = 3;
            _context.next = 6;
            return axiosAuth/* default.get */.Z.get('/api/users');

          case 6:
            response = _context.sent;
            userData = response.data;

            if (userData.allowedOnWebApp) {
              _context.next = 11;
              break;
            }

            window.location = "https://app.tacnique.com";
            return _context.abrupt("return");

          case 11:
            dispatch((0,usersSlice/* authUser */.uL)(userData));
            return _context.abrupt("return", userData);

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](3);

            if (!(((_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401)) {
              _context.next = 27;
              break;
            }

            if (!(((_error$response2 = _context.t0.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message) === "TokenExpired")) {
              _context.next = 24;
              break;
            }

            _context.next = 21;
            return handleAuthExpiredAccessToken();

          case 21:
            return _context.abrupt("return", axiosAuth/* default.get */.Z.get('/api/users').then(function (res) {
              return res.data;
            }));

          case 24:
            _context.next = 26;
            return logout({
              message: "sessionExpired"
            });

          case 26:
            return _context.abrupt("return");

          case 27:
            if (!(((_error$response3 = _context.t0.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) !== 409)) {
              _context.next = 29;
              break;
            }

            throw _context.t0;

          case 29:
            router.push("/verify-email");

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 15]]);
  })), {
    revalidateOnFocus: false,
    refreshInterval: 1800000,
    refreshWhenHidden: true
  }),
      user = _useSWR.data,
      error = _useSWR.error,
      revalidate = _useSWR.revalidate;

  var organization = user === null || user === void 0 ? void 0 : user.organization;

  var register = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
      var setErrors, setNotification, props;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setErrors = _ref3.setErrors, setNotification = _ref3.setNotification, props = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded);
              setErrors([]);
              loader.start();
              axiosAuth/* default.post */.Z.post("/api/auth/register", props).then(function (response) {
                var _response$data, _response$data$user, _response$data2, _response$data2$user, _response$data3, _response$data4;

                var uuid = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$user = _response$data.user) === null || _response$data$user === void 0 ? void 0 : _response$data$user.uuid;
                var organizationId = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$user = _response$data2.user) === null || _response$data2$user === void 0 ? void 0 : _response$data2$user.organizationId;
                props.uuid = uuid;
                props.organization_id = organizationId;
                return {
                  uuid: uuid,
                  organizationId: organizationId,
                  tokens: {
                    accessToken: response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.accessToken,
                    refreshToken: response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.refreshToken
                  }
                };
              }).then(function (data) {
                return axios/* default.post */.Z.post("/register", (0,utilities/* convertToFormData */.wh)(props)).then(function (response) {
                  var _data$tokens = data.tokens,
                      accessToken = _data$tokens.accessToken,
                      refreshToken = _data$tokens.refreshToken;
                  cookie_cutter_default().set("accessToken", accessToken, {
                    path: "/",
                    domain: ".tacnique.com",
                    secure: true
                  });
                  cookie_cutter_default().set("refreshToken", refreshToken, {
                    path: "/",
                    domain: ".tacnique.com",
                    secure: true
                  });
                  setNotification({
                    message: "Registration successful.",
                    type: "success"
                  });
                  setTimeout(function () {
                    return setNotification(null);
                  }, 5000);
                  revalidate();
                });
              })["catch"](function (error) {
                var _error$response4;

                setErrors([(_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.data.error]);
              })["finally"](function () {
                return loader.done();
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function register(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var login = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_ref5) {
      var setErrors, setStatus, props;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setErrors = _ref5.setErrors, setStatus = _ref5.setStatus, props = (0,objectWithoutProperties/* default */.Z)(_ref5, _excluded2);
              setErrors([]);
              setStatus(null);
              loader.start();
              axiosAuth/* default.post */.Z.post("/api/auth/login", props.payload).then(function (response) {
                if (response.status === 200 || response.status === 204) {
                  cookie_cutter_default().set("accessToken", response.data.accessToken, {
                    path: "/",
                    domain: ".tacnique.com",
                    secure: true
                  });
                  cookie_cutter_default().set("refreshToken", response.data.refreshToken, {
                    path: "/",
                    domain: ".tacnique.com",
                    secure: true
                  });
                }

                revalidate();
              })["catch"](function (error) {
                var _error$response5;

                setErrors([(_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.data.message]);
              })["finally"](function () {
                loader.done();
              });

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function login(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  var googleLogin = function googleLogin(_ref7) {
    var setErrors = _ref7.setErrors,
        setStatus = _ref7.setStatus,
        props = (0,objectWithoutProperties/* default */.Z)(_ref7, _excluded3);

    setErrors([]);
    setStatus(null);
    loader.start();
    axiosAuth/* default.post */.Z.post("/api/auth/google-login", props).then(function (response) {
      var _response$data5;

      cookie_cutter_default().set("accessToken", response.data.accessToken, {
        path: "/",
        domain: ".tacnique.com",
        secure: true
      });
      cookie_cutter_default().set("refreshToken", response.data.refreshToken, {
        path: "/",
        domain: ".tacnique.com",
        secure: true
      });

      if ((_response$data5 = response.data) !== null && _response$data5 !== void 0 && _response$data5.user) {
        // if the new user then register candidate
        var candidateCreate = {
          'uuid': response.data.user.uuid,
          'organization_id': response.data.user.organizationId
        };
        return axios/* default.post */.Z.post("/register", (0,utilities/* convertToFormData */.wh)(candidateCreate));
      }

      return Promise.resolve();
    }).then(function (response) {
      revalidate();
    })["catch"](function (error) {
      var _error$response6;

      setErrors([(_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.data.error]);
    })["finally"](function () {
      return loader.done();
    });
  };

  var forgotPassword = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(_ref8) {
      var setErrors, setStatus, email, encodedEmail;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setErrors = _ref8.setErrors, setStatus = _ref8.setStatus, email = _ref8.email;
              setErrors([]);
              setStatus(null);
              loader.start();
              encodedEmail = encodeURI(email);
              axiosAuth/* default.post */.Z.post("/api/auth/forgot-password", {
                email: encodedEmail
              }).then(function (response) {
                var _response$data6;

                return setStatus(response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.message);
              })["catch"](function (error) {
                var _error$response7;

                setErrors([(_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : _error$response7.data.message]);
              })["finally"](function () {
                return loader.done();
              });

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function forgotPassword(_x3) {
      return _ref9.apply(this, arguments);
    };
  }();

  var resetPassword = /*#__PURE__*/function () {
    var _ref11 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(_ref10) {
      var setErrors, setStatus, props;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setErrors = _ref10.setErrors, setStatus = _ref10.setStatus, props = (0,objectWithoutProperties/* default */.Z)(_ref10, _excluded4);
              setErrors([]);
              setStatus(null);
              loader.start();
              axiosAuth/* default.post */.Z.post("/api/auth/reset-password", _objectSpread({
                token: router.query.token
              }, props)).then(function (response) {
                var _response$data7;

                setStatus((response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.message) || "Password reset successfully");
                router.push("/login");
              })["catch"](function (error) {
                var _error$response8;

                setErrors([(_error$response8 = error.response) === null || _error$response8 === void 0 ? void 0 : _error$response8.data.message]);
              })["finally"](function () {
                return loader.done();
              });

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function resetPassword(_x4) {
      return _ref11.apply(this, arguments);
    };
  }();

  var forceResetPassword = /*#__PURE__*/function () {
    var _ref13 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(_ref12) {
      var setErrors, setStatus, props;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              setErrors = _ref12.setErrors, setStatus = _ref12.setStatus, props = (0,objectWithoutProperties/* default */.Z)(_ref12, _excluded5);
              setErrors([]);
              setStatus(null);
              loader.start();
              axiosAuth/* default.post */.Z.post("/api/auth/force-reset-password", _objectSpread({}, props)).then(function () {
                return router.push("/company/dashboard");
              })["catch"](function (error) {
                var _error$response9;

                setErrors([(_error$response9 = error.response) === null || _error$response9 === void 0 ? void 0 : _error$response9.data.message]);
              })["finally"](function () {
                return loader.done();
              });

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function forceResetPassword(_x5) {
      return _ref13.apply(this, arguments);
    };
  }();

  var forcedUpdateDetails = /*#__PURE__*/function () {
    var _ref15 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(_ref14) {
      var setErrors, setStatus, props;
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              setErrors = _ref14.setErrors, setStatus = _ref14.setStatus, props = (0,objectWithoutProperties/* default */.Z)(_ref14, _excluded6);
              setErrors([]);
              setStatus(null);
              loader.start();
              axiosAuth/* default.post */.Z.post("/api/users/force-update-details", _objectSpread({}, props)).then(function () {
                if (user.is_onboarding_completed) {
                  router.push("/engineer/interviews");
                } else {
                  router.push("/engineer/onboarding?stage=".concat(user === null || user === void 0 ? void 0 : user.onboarding_step));
                }
              })["catch"](function (error) {
                var _error$response10;

                setErrors([(_error$response10 = error.response) === null || _error$response10 === void 0 ? void 0 : _error$response10.data.message]);
              })["finally"](function () {
                return loader.done();
              });

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function forcedUpdateDetails(_x6) {
      return _ref15.apply(this, arguments);
    };
  }();

  var resendEmailVerification = function resendEmailVerification(_ref16) {
    var setStatus = _ref16.setStatus;
    loader.start(); // TODO: need to figure it out where it is used

    axios/* default.post */.Z.post("/email/verification-notification").then(function (response) {
      var _response$data8;

      return setStatus(response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.message);
    })["finally"](function () {
      return loader.done();
    });
  };

  var logout = /*#__PURE__*/function () {
    var _ref17 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8() {
      var _ref18,
          _ref18$message,
          message,
          destinationPath,
          queryParam,
          redirectURL,
          _args8 = arguments;

      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _ref18 = (_args8.length <= 0 ? undefined : _args8[0]) || {}, _ref18$message = _ref18.message, message = _ref18$message === void 0 ? "" : _ref18$message;
              destinationPath = (router === null || router === void 0 ? void 0 : router.asPath) || window.location.pathname;

              if (!error) {
                loader.start();
                cookie_cutter_default().set("accessToken", "", {
                  expires: new Date(0),
                  path: "/",
                  domain: ".tacnique.com",
                  secure: true
                });
                cookie_cutter_default().set("refreshToken", "", {
                  expires: new Date(0),
                  path: "/",
                  domain: ".tacnique.com",
                  secure: true
                });
                dispatch((0,usersSlice/* authUser */.uL)(undefined));
                localStorage.clear();
                (0,utilities/* deregisterAllServiceWorkers */.hE)();
                queryParam = "";
                redirectURL = destinationPath ? "redirect_to=".concat(encodeURIComponent(destinationPath)) : '';

                if (message === 'sessionExpired') {
                  queryParam = '?sessionexpired=1';
                }

                if (message !== "logout" && redirectURL) {
                  if (queryParam) {
                    queryParam += "&".concat(redirectURL);
                  } else {
                    queryParam = redirectURL ? "?".concat(redirectURL) : '';
                  }
                }

                window.location.href = "".concat("https://tacnique.com", "/login").concat(queryParam);
                loader.done();
              }

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function logout() {
      return _ref17.apply(this, arguments);
    };
  }();

  var handleAuthExpiredAccessToken = /*#__PURE__*/function () {
    var _ref19 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9() {
      var refreshToken, response;
      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              refreshToken = cookie_cutter_default().get("refreshToken");
              loader.start();

              if (refreshToken) {
                _context9.next = 6;
                break;
              }

              _context9.next = 5;
              return logout({
                message: "sessionExpired"
              });

            case 5:
              return _context9.abrupt("return");

            case 6:
              _context9.prev = 6;
              loader.start();
              _context9.next = 10;
              return axiosAuth/* default.post */.Z.post("/api/auth/refresh-token", {
                refreshToken: refreshToken
              });

            case 10:
              response = _context9.sent;

              if (!(response.status === 200)) {
                _context9.next = 17;
                break;
              }

              cookie_cutter_default().set("accessToken", response.data.accessToken, {
                path: "/",
                domain: ".tacnique.com",
                secure: true
              });

              if (response.data.refreshToken) {
                cookie_cutter_default().set("refreshToken", response.data.refreshToken, {
                  path: "/",
                  domain: ".tacnique.com",
                  secure: true
                });
              }

              revalidate();
              _context9.next = 19;
              break;

            case 17:
              _context9.next = 19;
              return logout({
                message: "sessionExpired"
              });

            case 19:
              _context9.next = 25;
              break;

            case 21:
              _context9.prev = 21;
              _context9.t0 = _context9["catch"](6);
              _context9.next = 25;
              return logout({
                message: "sessionExpired"
              });

            case 25:
              _context9.prev = 25;
              loader.done();
              return _context9.finish(25);

            case 28:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[6, 21, 25, 28]]);
    }));

    return function handleAuthExpiredAccessToken() {
      return _ref19.apply(this, arguments);
    };
  }();

  (0,react.useEffect)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10() {
    var destinationPath, redirectURL;
    return regenerator_default().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            destinationPath = (router === null || router === void 0 ? void 0 : router.asPath) || window.location.pathname;
            token = cookie_cutter_default().get("accessToken");

            if (!(!token && middleware !== "guest" && !constants/* guestRoutes.includes */.cO.includes(router === null || router === void 0 ? void 0 : router.pathname))) {
              _context10.next = 7;
              break;
            }

            redirectURL = destinationPath ? "/login?redirect_to=".concat(encodeURIComponent(destinationPath)) : '/login';
            _context10.next = 6;
            return router.push(redirectURL);

          case 6:
            cookie_cutter_default().set("destination_path", redirectURL, {
              path: "/"
            });

          case 7:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  })), []);
  (0,react.useEffect)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee11() {
    var _userRole, userIsCompany, userIsEngineer, _token, refreshToken, moduleName, openModules, companyModule, engineerModule, _router$asPath;

    return regenerator_default().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _userRole = (0,utilities/* userRole */.xZ)(user), userIsCompany = _userRole.userIsCompany, userIsEngineer = _userRole.userIsEngineer;

            if (!(middleware === "guest" && redirectIfAuthenticated && user)) {
              _context11.next = 29;
              break;
            }

            if (!user.missing_details) {
              _context11.next = 7;
              break;
            }

            _context11.next = 5;
            return router.push("/force-add-details");

          case 5:
            _context11.next = 29;
            break;

          case 7:
            if (!user.force_reset_password) {
              _context11.next = 12;
              break;
            }

            _context11.next = 10;
            return router.push("/force-reset-password");

          case 10:
            _context11.next = 29;
            break;

          case 12:
            if (!userIsCompany) {
              _context11.next = 17;
              break;
            }

            _context11.next = 15;
            return router.push(redirectIfAuthenticated.company);

          case 15:
            _context11.next = 29;
            break;

          case 17:
            if (!userIsEngineer) {
              _context11.next = 27;
              break;
            }

            if (!user.is_onboarding_completed) {
              _context11.next = 23;
              break;
            }

            _context11.next = 21;
            return router.push("/engineer/interviews");

          case 21:
            _context11.next = 25;
            break;

          case 23:
            _context11.next = 25;
            return router.push("/engineer/onboarding?stage=".concat(user === null || user === void 0 ? void 0 : user.onboarding_step));

          case 25:
            _context11.next = 29;
            break;

          case 27:
            _context11.next = 29;
            return router.push(redirectIfAuthenticated.fallback);

          case 29:
            if (!(middleware === "auth")) {
              _context11.next = 88;
              break;
            }

            _token = cookie_cutter_default().get("accessToken");
            refreshToken = cookie_cutter_default().get("refreshToken");

            if (!(!_token || !refreshToken)) {
              _context11.next = 35;
              break;
            }

            _context11.next = 35;
            return logout();

          case 35:
            if (!user) {
              _context11.next = 84;
              break;
            }

            if (!destination_path) {
              _context11.next = 40;
              break;
            }

            _context11.next = 39;
            return router.push(destination_path);

          case 39:
            cookie_cutter_default().set("destination_path", null, {
              expires: new Date(0),
              path: "/"
            });

          case 40:
            if (!user.missing_details) {
              _context11.next = 45;
              break;
            }

            _context11.next = 43;
            return router.push("/force-add-details");

          case 43:
            _context11.next = 82;
            break;

          case 45:
            if (!user.force_reset_password) {
              _context11.next = 50;
              break;
            }

            _context11.next = 48;
            return router.push("/force-reset-password");

          case 48:
            _context11.next = 82;
            break;

          case 50:
            moduleName = router.pathname.split("/")[1];
            openModules = ["force-reset-password"];

            if (openModules.includes(moduleName)) {
              _context11.next = 82;
              break;
            }

            companyModule = "company";
            engineerModule = "engineer";

            if (!(companyModule === moduleName && !userIsCompany)) {
              _context11.next = 63;
              break;
            }

            if (!userIsEngineer) {
              _context11.next = 61;
              break;
            }

            _context11.next = 59;
            return router.push("/engineer/profile");

          case 59:
            _context11.next = 63;
            break;

          case 61:
            _context11.next = 63;
            return logout();

          case 63:
            if (!(engineerModule === moduleName)) {
              _context11.next = 82;
              break;
            }

            if (userIsEngineer) {
              _context11.next = 74;
              break;
            }

            if (!userIsCompany) {
              _context11.next = 70;
              break;
            }

            _context11.next = 68;
            return router.push("/company/dashboard");

          case 68:
            _context11.next = 72;
            break;

          case 70:
            _context11.next = 72;
            return logout();

          case 72:
            _context11.next = 82;
            break;

          case 74:
            if (user.is_onboarding_completed) {
              _context11.next = 79;
              break;
            }

            _context11.next = 77;
            return router.push("/engineer/onboarding?stage=".concat(user === null || user === void 0 ? void 0 : user.onboarding_step));

          case 77:
            _context11.next = 82;
            break;

          case 79:
            if (!(router.pathname.split("/")[2] === "onboarding")) {
              _context11.next = 82;
              break;
            }

            _context11.next = 82;
            return router.push("/engineer/interviews?is_onboarded=true");

          case 82:
            _context11.next = 85;
            break;

          case 84:
            if ((router === null || router === void 0 ? void 0 : router.pathname) !== "/404" && !_token) {
              cookie_cutter_default().set("destination_path", (_router$asPath = router === null || router === void 0 ? void 0 : router.asPath) !== null && _router$asPath !== void 0 ? _router$asPath : window.location.pathname, {
                path: "/"
              });
            }

          case 85:
            if (!error) {
              _context11.next = 88;
              break;
            }

            _context11.next = 88;
            return logout();

          case 88:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  })), [user, error]);
  return {
    user: user,
    organization: organization,
    register: register,
    login: login,
    forgotPassword: forgotPassword,
    resetPassword: resetPassword,
    forceResetPassword: forceResetPassword,
    resendEmailVerification: resendEmailVerification,
    logout: logout,
    revalidate: revalidate,
    googleLogin: googleLogin,
    forcedUpdateDetails: forcedUpdateDetails,
    handleAuthExpiredAccessToken: handleAuthExpiredAccessToken
  };
};

/***/ }),

/***/ 97418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var cookie_cutter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49552);
/* harmony import */ var cookie_cutter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(cookie_cutter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_handleExpiredAccessToken__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65106);
/* harmony import */ var _lib_handleExpiredRefreshToken__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4552);






var axios = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
  baseURL: "https://app.tacnique.com",
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  },
  withCredentials: true
});
axios.interceptors.request.use(function (config) {
  var token = cookie_cutter__WEBPACK_IMPORTED_MODULE_2___default().get("accessToken");

  if (token) {
    config.headers.Authorization = "Bearer ".concat(token);
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  return response;
}, /*#__PURE__*/function () {
  var _ref = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(error) {
    var originalRequest, newToken;
    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            originalRequest = error.config;

            if (!(error.response && error.response.status === 401 && error.response.data.message === "Expired token")) {
              _context.next = 16;
              break;
            }

            _context.prev = 2;
            _context.next = 5;
            return (0,_lib_handleExpiredAccessToken__WEBPACK_IMPORTED_MODULE_3__/* .handleExpiredAccessToken */ .u)();

          case 5:
            newToken = _context.sent;

            if (!newToken) {
              _context.next = 9;
              break;
            }

            originalRequest.headers.Authorization = "Bearer ".concat(newToken);
            return _context.abrupt("return", axios(originalRequest));

          case 9:
            _context.next = 16;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            _context.next = 15;
            return (0,_lib_handleExpiredRefreshToken__WEBPACK_IMPORTED_MODULE_4__/* .handleExpiredRefreshToken */ .q)();

          case 15:
            return _context.abrupt("return", Promise.reject(_context.t0));

          case 16:
            return _context.abrupt("return", Promise.reject(error));

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 11]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
/* harmony default export */ __webpack_exports__["Z"] = (axios);

/***/ })

}]);